import type { TypedActionWithPayload } from '@/types/redux';

/* Action Types */
export const RETRACT_BID_FAIL = 'la/ui/retractBid/FAIL';
export const RETRACT_BID_REQUEST = 'la/ui/retractBid/REQUEST';

export const RETRACT_BID_SUCCESS = 'la/ui/retractBid/SUCCESS';
export type RETRACT_BID_SUCCESS_ACTION = TypedActionWithPayload<
    typeof RETRACT_BID_SUCCESS,
    number,
    {
        analytics: any;
        itemId: number;
    }
>;
